import React from 'react';
import PropTypes from 'prop-types';

import {Box, Paper, Typography} from 'views/components';
import {Translate} from 'views/module';

import CohortGraphData from './CohortGraphData';

const CohortSection = (props) => {
  const {
    chartHeight = 340,
    isLoading,
    errorMessage,
    metricsByDate,
    currentDate,
    previousDates,
  } = props;

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '11px',
          fontWeight: 600,
          lineHeight: '14px',
          letterSpacing: '0.04em',
          color: '#A8A49E',
          mb: 2,
        }}
      >
        <Translate expression='metrics.LeadFunnel.CohortSection' />
      </Typography>
      <Paper
        sx={{
          p: 3,
          borderRadius: '12px',
          border: '1px solid #E5E5E5',
          boxShadow: 'none',
        }}
      >
        <CohortGraphData
          chartHeight={chartHeight}
          isLoading={isLoading}
          errorMessage={errorMessage}
          metricsByDate={metricsByDate}
          currentDate={currentDate}
          previousDates={previousDates}
        />
      </Paper>
    </Box>
  );
};

CohortSection.propTypes = {
  chartHeight: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  metricsByDate: PropTypes.object.isRequired,
  currentDate: PropTypes.string.isRequired,
  previousDates: PropTypes.array.isRequired,
};

export default React.memo(CohortSection);
